'use strict';

var self = module.exports = {

  init: function () {

    var $gallery = $('.gallery-artwork__carousel_theme_steal');

    /************************************************************************************************************************
     * Inizializza la gallery
     /***********************************************************************************************************************/

    /**
     * Inizializza la gallery delle opere
     *
     * @plugin
     */
    $gallery.owlCarousel({
      center: true,
      dots: false,
      lazyLoad: true,
      loop: true,
      nav: true,
      navContainer: '.gallery-artwork__nav_theme_steal',
      navElement: 'div class="gallery-artwork__controls carousel__controls carousel__controls_theme_white"',
      navText: false,
      rewind: false,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 4
        },
        1680: {
          items: 6
        }
      }
    });

    /**
     * Link applicato su ogni elemento artwork
     * scatena la funzione 'choose' solamente
     * se l'opera è selezionata al centro della gallery
     * altrimenti muove il carousel in base all'opera selezionata
     */
    $('[data-js="steal-link-choose"]').click(function() {

      var $move = $(this).closest('.artwork').attr('data-position');

      if ($(this).closest('.center').length > 0) {
        self.choose();
      }

      $('.gallery-artwork__carousel').trigger('to.owl.carousel', $move);

    });

    /**
     * Button che scatena la funzione 'choose'
     */
    $('[data-js="steal-button-choose"]').click(function() {
      self.choose();
    });

  },
  choose: function () {

    /************************************************************************************************************************
     * Salvataggio
     /***********************************************************************************************************************/

    $(document).find('.editor__canvas').attr('data-modified', 0);

    var $gallery = $('.gallery-artwork__carousel_theme_steal'),
      $canvas = $('.canvas'),
      $artworkSelected = $gallery.find('.center').find('.artwork'),
      $items = $artworkSelected.data('json'),
      $color = $artworkSelected.data('background');

    $(document).find('.editor__canvas').attr('data-parent', $artworkSelected.data('artwork'));

    /**
     * Rimuovo tutti gli elementi all'interno del canvas
     */
    $canvas.find('.draggable').remove();

    /**
     * Imposto il colore di background del canvas
     */
    $canvas.css('background-color', $color);

    /**
     * Costruzione dell'artwork:
     * - itero il json ricostruendo l'html per ogni elemento/cibo
     * - per ogni elemento/cibo setto i data
     */
    for(var index in $items) {
      $canvas.append('' +
        '<div class="draggable ' + ($items[index].isCabbage ? 'draggable_theme_cabbage' : 'draggable_theme_all')  + ' ui-draggable ui-draggable-handle ui-draggable-dragging draggable_deep_1" data-tag="' + $items[index].item + '" style="position: absolute; left: ' + $items[index].positionLeft + '; top: ' + $items[index].positionTop + ';">' +
        ' <div class="draggable__item" style="transform: scale(' + $items[index].flipX  + ', ' + $items[index].flipY  + ') rotate(' + $items[index].rotate  + 'deg);"  data-original-width="' + $items[index].originalWidth  + '" data-original-height="' + $items[index].originalHeight  + '">' +
        '   <img class="draggable__image owl-lazy" alt="' + $items[index].item + '" src="/media/cache/small/media/items/images/' + $items[index].item + '.png" style="opacity: 1;">' +
        ' </div>' +
        ' <div class="draggable__viewfinder"></div>' +
        '</div>');

      $canvas
        .find('.draggable')
        .eq(index)
        .find('.draggable__item')
        .data({
          'flipX': $items[index].flipX,
          'flipY': $items[index].flipY,
          'isCabbage': $items[index].isCabbage,
          'position-top': $items[index].positionTop,
          'position-left':$items[index].positionLeft,
          'rotate': $items[index].rotate
        });
    }

    $('.draggable')
      .draggable({
        containment: '.canvas',
        cursor: 'move'
      });

    /**
     * Dopo il salvataggio:
     * - si chiude la modal
     */
    $('#modal-steal').foundation('close');
  }
}

self.init();
